



















































import { Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";

import AliasedRequestProgressContainer from "@/components/ui/AliasedRequestProgressContainer.vue";

import { capitalizeFilter } from "@/filters/capitalize.filter";

import { GetMyInvoicesFalconRequest } from "@/interfaces/falcon/get-my-invoices/get-my-invoices-falcon-request";
import { GetMyInvoicesInvoiceListItem } from "@/interfaces/falcon/get-my-invoices/get-my-invoices-invoice-list-item";

import { RequestAlias } from "@/enums/request-alias.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon document details table aside component
 */
@Component({
  components: { AliasedRequestProgressContainer },
  filters: {
    ...capitalizeFilter
  }
})
export default class DocumentDetails extends Vue {
  @State(state => state.falconDocuments.documentDetailsData)
  private documentDetails!: GetMyInvoicesInvoiceListItem;
  @Action("falconDocuments/getDocumentDetails") private getDocumentDetails!: (
    request: GetMyInvoicesFalconRequest
  ) => void;

  requestAlias = RequestAlias.GetMyInvoicesDetails;
  i18nMessageKeyEnum = I18nMessageKey;

  @Watch("$route", { immediate: true })
  private routeUpdated(): void {
    this.getDocumentDetails({
      getMyInvoices: {
        documentIdList: {
          id: [this.$route.params.documentId]
        },
        getItems: 1
      }
    });
  }

  /**
   * Returns complaint creation url for given documents data
   * @param documentId Document id
   * @param itemId Document item id
   * @param productId Document product id
   */
  getComplaintCreationUrl(
    documentId: string,
    itemId: string,
    productId: string
  ): string {
    return `/app/falcon/complaints/create/${documentId}/${itemId}/${productId}/step`;
  }
}
